"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortCommentsByLanguage = sortCommentsByLanguage;

/**
 * Given an array of comments, sort them by language, first "ES" then "EN", and then the rest.
 * @param {Array} comments
 * @returns {Array}
 */
function sortCommentsByLanguage(comments) {
  var first_choice = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'es';
  var second_choice = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'en';
  var sortedComments = comments.sort(function (a, b) {
    if (a.lang === first_choice) {
      return -1;
    }

    if (b.lang === first_choice) {
      return 1;
    }

    if (a.lang === second_choice) {
      return -1;
    }

    if (b.lang === second_choice) {
      return 1;
    }

    return 0;
  });
  return sortedComments;
}